import hiLocale from 'element-ui/lib/locale/lang/en'
import home from './hi/home'

const hi = {
    language: 'हिन्दी',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': 'मोबाइल फोन नंबर की न्यूनतम लंबाई 8 अंक है',
    '邮箱账号名称最小长度为6位': 'ईमेल खाते के नाम की न्यूनतम लंबाई 6 अक्षर है',
    '邮箱只能包含英文，数字等字符': 'ईमेल में केवल अंग्रेजी, संख्याएं और अन्य अक्षर हो सकते हैं',
    '请选择正确的收货地址': 'कृपया सही डिलीवरी पता चुनें',
    ...hiLocale
}
export default hi